import React from "react";

// Chakra imports
import { Box, Flex, Icon, Text, useColorModeValue } from "@chakra-ui/react";
import BarChart from "../../../../components/admindashboard/charts/BarChart";

// Custom components
import Card from "../../../../components/admindashboard/card/Card";
import {
  barChartDataDailyTraffic,
  barChartOptionsDailyTraffic,
} from "variables/charts";

// Assets
import { RiArrowUpSFill } from "react-icons/ri";

export default function DailyTraffic(props) {
  const {
    title = "Daily Traffic",
    value = "0",
    label = "Visitors",
    growthValue = "0%",
    growthPositive = true,
    chartData = barChartDataDailyTraffic,
    chartOptions = barChartOptionsDailyTraffic,
    ...rest
  } = props;

  // Chakra Color Mode
  const textColor = useColorModeValue("secondaryGray.900", "white");
  return (
    <Card align='center' direction='column' w='100%' {...rest}>
      <Flex justify='space-between' align='start' px='10px' pt='5px'>
        <Flex flexDirection='column' align='start' me='20px'>
          <Flex w='100%'>
            <Text
              me='auto'
              color='secondaryGray.600'
              fontSize='sm'
              fontWeight='500'>
              {title}
            </Text>
          </Flex>
          <Flex align='end'>
            <Text
              color={textColor}
              fontSize='34px'
              fontWeight='700'
              lineHeight='100%'>
              {value}
            </Text>
            <Text
              ms='6px'
              color='secondaryGray.600'
              fontSize='sm'
              fontWeight='500'>
              {label}
            </Text>
          </Flex>
        </Flex>
        <Flex align='center'>
          <Icon
            as={RiArrowUpSFill}
            color={growthPositive ? 'green.500' : 'red.500'}
            transform={growthPositive ? 'none' : 'rotate(180deg)'}
          />
          <Text color={growthPositive ? 'green.500' : 'red.500'} fontSize='sm' fontWeight='700'>
            {growthValue}
          </Text>
        </Flex>
      </Flex>
      <Box h='240px' mt='auto'>
        <BarChart
          chartData={chartData}
          chartOptions={chartOptions}
        />
      </Box>
    </Card>
  );
}
